"use client";

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  IconButton,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Pagination,
} from "@mui/material";
import { Edit, Delete, Search } from "@mui/icons-material";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

const CategoryList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [businessTypes, setBusinessTypes] = useState([]);
 //console.log("Business Types:", businessTypes);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [editCategoryName, setEditCategoryName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editStatus, setEditStatus] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [newImage, setNewImage] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/getall-category`)
      .then((res) => {
       //console.log("Raw Response:", res);
        return res.json();
      })
      .then((data) => {
       //console.log("Parsed JSON:", data);
        setBusinessTypes(data || []);
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
      });
  }, []);


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
    setCurrentPage(1);
  };

  const filteredItems = Array.isArray(businessTypes)
    ? businessTypes.filter((item) =>
      item.category_name?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];



  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
 //console.log("Current Items:", currentItems);

  const handleEditClick = (businessType) => {
    setSelectedBusinessType(businessType);
    setEditCategoryName(businessType.category_name);
    setEditDescription(businessType.description);
    setEditStatus(businessType.status);
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this business type?")) {
      await fetch(`${process.env.REACT_APP_API_URL}/api/admin/save-category`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ _id: id }),
      });
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/save-category`);
      const data = await res.json();
      setBusinessTypes(data);
    }
  };

  const handleCreateCategory = async () => {
    const payload = {
      category_name: newCategoryName,
      description: newDescription,
      status: true, // default active
    };

    await fetch(`${process.env.REACT_APP_API_URL}/api/admin/save-category`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    setShowCreateModal(false);
    setNewCategoryName("");
    setNewDescription("");
    setNewImage(null);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/save-category`);
    const data = await res.json();
    setBusinessTypes(data);
  };

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <TextField
            label="Search here"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <Search sx={{ mr: 1 }} />,
            }}
          />

          <Box mb={2} display="flex" justifyContent="flex-end">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setShowCreateModal(true)}
              sx={{
                px: { xs: 2, sm: 4 },
                py: 1,
                fontSize: 14,
                fontWeight: 500,
                borderRadius: 2,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "primary.light",
                },
              }}
            >
              Add New Category
            </Button>
          </Box>
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table sx={{ minWidth: 1300 }} aria-label="business table">
            <TableHead className="bg-primary-50">
              <TableRow
                sx={{
                  th: {
                    fontWeight: "500",
                    padding: "10px 24px",
                    fontSize: "14px",
                  },
                }}
              >
                <TableCell sx={{}} className="text-black border-bottom">ID</TableCell>
                <TableCell className="text-black border-bottom">Category</TableCell>
                <TableCell className="text-black border-bottom">Description</TableCell>
                <TableCell className="text-black border-bottom">Status</TableCell>
                <TableCell className="text-black border-bottom">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentItems.length > 0 ? (
                currentItems.map((item, i) => (
                  <TableRow key={item._id || i}>
                    <TableCell>#{item._id?.slice(-4)}</TableCell>
                    <TableCell>{item.category_name}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell>
                      <Typography
                        variant="caption"
                        sx={{
                          backgroundColor: item.status ? "#C8E6C9" : "#FFCDD2",
                          color: item.status ? "#2E7D32" : "#C62828",
                          px: 1,
                          py: 0.5,
                          borderRadius: 1,
                        }}
                      >
                        {item.status ? "Active" : "Inactive"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => handleEditClick(item)}
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDelete(item._id)}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No categories found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {filteredItems.length > itemsPerPage && (
          <Box mt={2} display="flex" justifyContent="center">
            <Pagination
              count={Math.ceil(filteredItems.length / itemsPerPage)}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              shape="rounded"
              color="primary"
            />
          </Box>
        )}
      </CardContent>
      <Dialog
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Create Category</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" gutterBottom>
            Add A Category
          </Typography>

          <TextField
            fullWidth
            label="Category Name"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Description"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
            multiline
            rows={3}
            margin="normal"
          />

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              Upload Image
            </Typography>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 120,
                borderStyle: "dashed",
              }}
            >
              <input
                accept="image/*"
                type="file"
                onChange={(e) => setNewImage(e.target.files[0])}
              />
            </Paper>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setShowCreateModal(false)}
            variant="contained"
            color="error"
          >
            Cancel
          </Button>
          <Button onClick={handleCreateCategory} variant="contained" color="primary">
            + Create Category
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Business Type</DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            margin="normal"
            label="Category Name"
            value={editCategoryName}
            onChange={(e) => setEditCategoryName(e.target.value)}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Description"
            multiline
            rows={3}
            value={editDescription}
            onChange={(e) => setEditDescription(e.target.value)}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={editStatus ? "active" : "inactive"}
              label="Status"
              onChange={(e) => setEditStatus(e.target.value === "active")}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowEditModal(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={async () => {
              await fetch(`${process.env.REACT_APP_API_URL}/api/admin/save-category`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  category_name: editCategoryName,
                  description: editDescription,
                  status: editStatus,
                  _id: selectedBusinessType._id,
                }),
              });
              setShowEditModal(false);
              const res = await fetch("${process.env.REACT_APP_API_URL}/api/admin/save-category");
              const data = await res.json();
              setBusinessTypes(data);
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CategoryList;
